module.exports = __webpack_public_path__ + "img/screenshot_1_footer.8e548e04.jpg";